import type { Location, USAStateAcronym } from '@hc-frontend/core-types';
import { USAStatesList } from '@hc-frontend/core-types';
import { createSuccessOperationResult } from '@hc-frontend/core-utils-business-operation';
import { getSafeURLParameters } from '@hc-frontend/core-utils-dom';
import { removeEmptyKeys } from '@hc-frontend/core-utils-object';

import type { HandleContextualTrafficGetLocationParametersResult } from '../../domain';
import { getParameterValueByKeySet } from './get-parameter-value-by-key-set';

function UpperCase(value: string | undefined) {
  return value ? value.toUpperCase() : undefined;
}

function transformState(value?: string) {
  if (value === undefined) {
    return undefined;
  }

  const lowerCaseValue = value.trim().toLowerCase();

  if (lowerCaseValue.length === 2) {
    return USAStatesList.find(
      (state) => UpperCase(lowerCaseValue) === state.code,
    )?.name;
  }

  return USAStatesList.find(
    (state) => lowerCaseValue === state.name.toLowerCase(),
  )?.name;
}

export async function getLocationParameters({
  landingUrl,
}: {
  landingUrl: string;
}): HandleContextualTrafficGetLocationParametersResult {
  const urlParameters = getSafeURLParameters(landingUrl, true);

  const location: Partial<Location> = removeEmptyKeys({
    zipCode: getParameterValueByKeySet(urlParameters, ['zip', 'zipcode']),
    state: transformState(getParameterValueByKeySet(urlParameters, ['state'])),
    stateAcronym: UpperCase(
      getParameterValueByKeySet(urlParameters, ['st']),
    ) as USAStateAcronym,
    county: getParameterValueByKeySet(urlParameters, ['county']),
    city: getParameterValueByKeySet(urlParameters, ['city']),
  });

  return createSuccessOperationResult(location);
}
